(function($) {

	'use strict';

	var init = function() {
        $(".who__columns__link").on("click", function() {
			$(".who__columns__link, .who__compare").toggleClass("active");
			$(".who__columns__link").text(function(i, text){
                return text === "Fermer" ? "Comparer" : "Fermer";
            })
		});
	};
	


	$(document).ready(function() {
		init();
	});

})(jQuery);
